/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-rime-hero video: play only the displayed <video>, pause any hidden by CSS
   (mobile/desktop swap, phones-off, reduced motion). Playback itself needs no
   JS — the autoplay attribute starts it; this only stops what should not run. */
(function () {
  if (window.__qpRimeHeroVideo) return;
  window.__qpRimeHeroVideo = true;

  var mm = window.matchMedia ? window.matchMedia.bind(window) : null;
  var reduce = mm ? mm('(prefers-reduced-motion: reduce)') : null;
  var narrow = mm ? mm('(max-width: 767px)') : null;

  function sync() {
    var videos = document.querySelectorAll('.qp-rime-hero__video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      var shown = v.getClientRects().length > 0;
      if (shown && !(reduce && reduce.matches)) {
        if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (!v.paused) {
        v.pause();
      }
    }
  }

  function listen(q) {
    if (!q) return;
    if (q.addEventListener) q.addEventListener('change', sync);
    else if (q.addListener) q.addListener(sync);
  }

  listen(reduce);
  listen(narrow);
  document.addEventListener('shopify:section:load', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
